<template>
	<div id="singleMeets">
		<el-card shadow="always" class="box-card" v-loading="loading">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline" >
        <el-form-item >
          <el-radio-group v-model="queryForm.status"  @input="onClickRadioStatus">
            <el-radio-button  v-for="item in statusList":label="item.value"  :key="item.value"  >{{ item.label }} ({{ statusCounts[item.value] || 0 }})</el-radio-button>
          </el-radio-group>
        </el-form-item>

				<el-form-item >
					<el-input clearable v-model="queryForm.projectName" placeholder="项目名称关键字查找"></el-input>
				</el-form-item>

        <el-form-item >
          <el-input clearable v-model="queryForm.fullName"  placeholder="项目负责人关键字查找"></el-input>
        </el-form-item>

        <el-form-item >
          <el-input clearable  v-model="queryForm.supplierName" placeholder="供应商名称查找"></el-input>
        </el-form-item>

        <el-form-item >
          <el-input clearable  v-model="queryForm.applicationForm" placeholder="费用申请单编号"></el-input>
        </el-form-item>

        <el-form-item >
          <el-input clearable  v-model="queryForm.reimbursementNum" placeholder="费用报销单编号"></el-input>
        </el-form-item>
        <el-form-item >
          <el-input clearable v-model="queryForm.clearingBuyerName"  placeholder="结算负责人"></el-input>
        </el-form-item>

				<el-form-item>
					<el-button type="primary" @click="onSearch">查询</el-button>
					<el-button type="info" @click="reSet" icon="el-icon-search">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 项目列表 -->
		<el-card shadow="always" class="table-card">
			<el-table :data="dataList" border style="width: 100%">
				<el-table-column align="center" prop="id" label="编号" width="80"></el-table-column>
        <el-table-column align="center" prop="projectName" label="项目名称"  min-width="200" ></el-table-column>
<!--        <el-table-column align="center" prop="fullName" label="采购负责人" min-width="100" ></el-table-column>-->
        <el-table-column align="center" prop="clearingBuyerName" label="结算负责人" min-width="100" ></el-table-column>
        <el-table-column align="center" prop="fullName" label="项目负责人"  min-width="100"></el-table-column>
        <el-table-column align="center" prop="supplierName" label="供应商名称" min-width="150" ></el-table-column>
        <el-table-column align="center" prop="applicationForm" label="费用申请单号"  min-width="140" ></el-table-column>
        <el-table-column align="center" prop="reimbursementNum" label="费用报销单号"  min-width="140"></el-table-column>
<!--        <el-table-column align="center" prop="" label="费用承担组织" min-width="120" ></el-table-column>-->
        <el-table-column align="center" prop="createTime" label="发起时间"min-width="140">
          <template slot-scope="scope">
            {{ $moment(scope.row.createTime).format('L') }}
            {{ $moment(scope.row.createTime).format('LT') }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="updateTime" label="更新时间" min-width="140" >
          <template slot-scope="scope">
            {{ $moment(scope.row.updateTime).format('L') }}
            {{ $moment(scope.row.updateTime).format('LT') }}
          </template>
        </el-table-column>
				<el-table-column align="center" prop="applyMoney" label="申请金额(元)" width="110"/>
        <el-table-column align="center" prop="" label="是否超出中标金额" width="140" >
          <template slot-scope="scope">
            <!-- 仅当 isOverBudget 有有效值时才显示 tag -->
            <el-tag
                v-if="isValidOverBudget(scope.row.isOverBudget)"
                :type="isOverBudget(scope.row) ? 'danger' : 'success'"
                disable-transitions
            >
              {{ isOverBudget(scope.row) ? '是' : '否' }}
            </el-tag>
          </template>

        </el-table-column>

<!--				<el-table-column align="center" prop="type" label="类型" :formatter="formatType"-->
<!--					width="180"></el-table-column>-->
				<el-table-column align="center" prop="type" label="收费方式"  min-width="100">
					<template v-slot:default="scope">
						{{collectWayEnums[scope.row.collectWay]}}
					</template></el-table-column>

				<el-table-column align="center" prop="status" label="审核状态" min-width="100">
					<template v-slot:default="scope">
						<span v-if="scope.row.status =='OFFICIAL_EXAMINE'">待审核</span>
						<span v-else-if=" scope.row.status=='SUCCESS'">复审通过</span>
						<span v-else-if=" scope.row.status=='SUBMIT'">财务审核中</span>
						<span v-else-if=" scope.row.status=='AI_REVIEW_SUCCESS'">AI预审中</span>
            <span v-else-if=" scope.row.status=='FINISH'">已打款</span>
            <span v-else-if=" scope.row.status=='REJECTED'">金蝶驳回</span>
						<div v-else-if="scope.row.status=='ERROR'">
							<span style="margin-right: 2px">官员驳回</span>
<!--							<el-tooltip effect="dark" trigger="hover" placement="right-start"-->
<!--								:content="scope.row.errorMessage">-->
<!--								<el-icon class="el-icon-warning-outline">-->
<!--									<span>{{ scope.row.errorMessage }}</span></el-icon>-->
<!--							</el-tooltip>-->
						</div>
            <div v-else>{{scope.row.status}}</div>
					</template>
				</el-table-column>

        <el-table-column align="center" prop="type" label="付款日期"  min-width="120">
          <template v-slot:default="scope">
            {{scope.row.realPayTime}}
          </template>
        </el-table-column>


				<el-table-column label="操作" width="100" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="text"
							@click="toDetails(scope.row)">{{scope.row.status=='OFFICIAL_EXAMINE'|| scope.row.status=='REJECTED' ?'审核':'查看'}}</el-button>

            <el-button v-if="scope.row.reimbursementNum" size="mini" type="text"
                       @click="toJdCloud(scope.row.id)">跳转金蝶</el-button>
            <el-button v-if="scope.row.reimbursementNum && (scope.row.status!='FINISH')  " size="mini" type="text"
                       @click="syncKingdeeStatus(scope.row.id)">同步金蝶状态</el-button>

            <el-button v-if="scope.row.reimbursementNum && scope.row.status=='FINISH'" size="mini" type="text"
                       @click="syncPaymentDate(scope.row.id)">同步付款日期</el-button>

					</template>
				</el-table-column>
			</el-table>


			<div class="pagination" style="margin-top: 10px">
				<TablePaging :currentPage="queryForm.current" :total="queryForm.total" :pageSize="queryForm.size"
					@pageChange="handleCurrentChange" />
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		getSpendingOrderListByPage,fetchStatusCounts,redirctUrl,kingdeeStatus,syncPaymentDate
	} from '@/request/api.js';
	import TablePaging from '@/components/TablePaging.vue';

	export default {
		name: 'index',
		components: {
			TablePaging
		},
		data() {
			return {
       statusCounts:[],
        // orderColumn: [
        //   {label: '全部', value: 'ALL'},
        //   {label: '初审中', value: '2'},
        //   {label: '初审驳回', value: '3'},
        //   {label: '复审中', value: '5'},
        //   {label: '复审驳回', value: '10'},
        //   {label: '复审通过', value: '11'},
        //   {label: '已打款', value: '12'},
        // ],

        statusList: [{
          label: '全部',
          value: 'ALL'
        },
          {
            label: '待审核',
            value: 'OFFICIAL_EXAMINE'
          },
          {
            label: '审核驳回',
            value: 'ERROR'
          },
          {
            label: '财务审核中',
            value: 'SUBMIT'
          },
          {
            label: '金蝶驳回',
            value: 'REJECTED'
          },
          {
            label: '复审通过',
            value: 'SUCCESS'
            //对应5
          },

          {
            label: '已打款',
            value: 'FINISH'
          },
        ],

				collectWayEnums: {
					"0": "一次性收款并结项",
					"1": "首次收款",
					"2": "阶段收款",
					"3": "尾款",
					"4": "据实结算",
				},
				queryForm: {
					current: 1,
					size: 10,
					total: 0,
					status: "ALL",
					// orderName:"",
					projectTimeRange: []
					// projectType: 'single'
				},
				dataList: [],


				loading: false,
				projectList: [],
			}
		},

		mounted() {
			this.loadData();
      this.fetchStatusCounts()
		},
		methods: {



      // 判断是否是有效的布尔/标识值（排除 null, undefined, ''）
      isValidOverBudget(val) {
        return val !== null && val !== undefined && val !== '';
      },

      // 判断是否超支（仅在 isValidOverBudget 为 true 时调用）
      isOverBudget(row) {
        const val = row.isOverBudget;
        return [true, 1, '1', 'true'].includes(val);
      },

      fetchStatusCounts(){
        fetchStatusCounts().then(res=>{
          if(res.code==200){
            const countMap = {};
            (res.data || []).forEach(item => {
              countMap[item.status] = item.total;
            });
            this.statusCounts=countMap;

          }
        })
      },

      onClickRadioStatus(status){
        console.log('当前选中的值:', status);
        this.queryForm.current=1
        this.loadData()
      },

			toDetails(item) {
				//供应商结算
				//   this.$router.push({
				//     name: 'settlementAudit',
				//     query: {
				//       orderId: item.id,
				//       // pId:item.projectId,
				//       // mId:item.meetingId,
				//       // collectWay:item.collectWay,
				//       // feeType:item.feeType,
				//     }
				//   })

				this.$router.push({
					name: 'fileListPreviewnew',
					query: {
						orderId: item.id
					}
				});



				// if(item.type=="DOCTOR"){
				//   //劳务结算
				//   this.$router.push({
				//     name: 'uploadFile',
				//     query: {
				//       mId: item.id,
				//       // status: item.meetingStatus,
				//       // now: '4'
				//     }
				//   })
				// }else {
				//   this.supplierSettlement(item)
				// }

			},
      // //跳转到金蝶
      // toJdCloud(orderId){
      //   redirctUrl({orderId: orderId}).then(res=>{
      //     if(res.code==200){
      //       window.open(res.data);
      //     }else {
      //       this.$message.error(res.msg);
      //     }
      //   })
      // },


      // 跳转到金蝶
      toJdCloud(orderId) {
        this.$confirm(
            '<div>即将跳转至金蝶云星空系统进行操作。</div>' +
            '<div style="margin-top: 12px; color: #f56c6c; font-weight: bold;">' +
            '⚠️ 重要提示：在金蝶完成【提交/保存/审核】操作后，' +
            '请务必返回本系统，点击操作栏中的 <span style="color: red;">“同步金蝶状态”</span> 按钮，' +
            '以确保万木系统与金蝶数据保持一致！' +
            '</div>',
            '操作提醒',
            {
              dangerouslyUseHTMLString: true, // 允许使用 HTML
              confirmButtonText: '继续跳转',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          // 用户点击“继续跳转”
          redirctUrl({ orderId: orderId }).then(res => {
            if (res.code === 200) {
              window.open(res.data, '_blank'); // 在新标签页打开
            } else {
              this.$message.error(res.msg || '跳转失败');
            }
          }).catch(err => {
            console.error('redirect error:', err);
            this.$message.error('请求跳转地址失败');
          });
        }).catch(() => {
          // 用户点击“取消”
          this.$message.info('已取消跳转');
        });
      },






      //同步付款日期
      syncPaymentDate(orderId){
        this.$confirm('确定要同步金蝶付款日期吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户点击“确定”，发起请求
          syncPaymentDate({ orderId: orderId }).then(res => {
            if (res.code === 200) {
              this.$message.success('付款日期同步成功');
              this.loadData()
            } else {
              this.$message.error(res.msg || '同步失败');
            }
          }).catch(err => {
            console.error('同步付款日期请求异常:', err);
            this.$message.error('网络错误，请稍后重试');
          });
        }).catch(() => {
          // 用户点击“取消”或关闭弹窗
          this.$message.info('已取消同步付款日期');
        });

      },

      syncKingdeeStatus(orderId){
        this.$confirm('确定要同步金蝶报销单状态吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户点击“确定”
          kingdeeStatus({ orderId: orderId }).then(res => {
            if (res.code === 200) {
              this.$message.success('同步成功');
              this.loadData()
              this.fetchStatusCounts()
            } else {
              this.$message.error(res.msg || '同步失败');
            }
          }).catch(err => {
            console.error('同步请求异常:', err);
            this.$message.error('网络错误，请稍后重试');
          });
        }).catch(() => {
          // 用户点击“取消”或关闭弹窗
          this.$message.info('已取消同步');
        });

      },



			// // 供应商结算
			// supplierSettlement(item) {
			//   this.ckMeetingId = item.id;
			//   this.loading = true;
			//   this.getCollectWayFun(item);
			//
			//   getOrderByMeetId({
			//     meetingId: item.id,
			//   }).then(res => {
			//     this.orderData = res.data;
			//     if (this.orderData) {
			//       this.loading = false;
			//       this.toSupplierSettlement()
			//       console.log('有记录')
			//     } else {
			//       this.loading = false;
			//       this.settleAccountsShow = true;
			//       console.log('无记录')
			//     }
			//   })
			// },


			onSearch() {
				this.queryForm.current = 1;
				this.loadData()
			},


			// formatStatus(row, column, cellValue) {
			//   console.log(cellValue)
			//   const statusMap = {
			//     'CREATED': '本地保存',
			//     'AI_REVIEW': '预审中',
			//     'AI_REVIEW_SUCCESS': '预审成功',
			//     'WAIT': '待提交',
			//     'SUBMIT': '已提交',
			//     'SUCCESS': '审核成功',
			//     'FINISH': '已完成',
			//     'ERROR': '被驳回',
			//     'OFFICIAL_EXAMINE': '待审核'
			//   };
			//   return statusMap[cellValue] || '未知状态';
			// },

			formatType(row, column, cellValue) {
				// const statusMap = {
				//   'DOCTOR': '劳务发放',
				//   'OTHER': '项目回款'
				// };
				// return statusMap[cellValue] || '未知状态';
				//后端没返回 医生供应商没合并默认全部项目汇款
				return '项目回款';
			},

			reSet() {
				this.queryForm = {
					current: 1,
					size: 10,
					total: 0,
					status: "ALL"
				}
				this.loadData()
			},
			handleSizeChange(val) {
				this.queryForm.size = val;
				this.loadData()
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.queryForm.current = val;
				this.loadData()
				console.log(`当前页: ${val}`);
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				console.log(row.projectStatus)
				if (row.projectStatus === 'UNDERWAY') { //进行中
					return 'warning-row';
				} else if (row.projectStatus === 'TIMEOUT') { //已结束
					return 'end-row';
				} else if (row.projectStatus === 'WAIT_CLAIM') { //待认领
					return 'warning-row';
				}
				return '';
			},



			// 获取table数据列表
			loadData() {
				const params = {
					...this.queryForm
				};
				if (params.status == 'ALL') {
					delete params.status;
				}
				console.log("执行")
				getSpendingOrderListByPage(params).then(res => {
					if (res.code == 200) {
						this.dataList = res.data.records;
						this.queryForm.total = res.data.total
					}
				})
			},
		}
	}
</script>

<style lang="scss">
	.el-table .warning-row {
		background: oldlace;
	}

	//.el-table .end-row{
	//  background: #d3d4d6;
	//}
	.el-table .success-row {
		background: #f0f9eb;
	}

	#singleMeets {
		//display: flex;
		//height: auto;
		//flex-direction: column;

		.box-card {
			// margin: 20px 20px 0;
			padding: 20px 20px 0;
			// border-radius: 10px;
		}

		.table-card {
			// margin: 20px 20px 0;
			//padding: 20px 20px 0;
			// border-radius: 10px;
		}

    .demo-form-inline{

    }

	}
</style>
